<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productProfile.pageTitle'),
            href: '/admin/product-profiles',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-4">
              <ProductInfo
                v-model="model"
                :validate="errors"
                @loading="(value) => loading = value"
                class="ts-w-full ts-border ts-p-4 ts-rounded-lg ts-border-gray-200"
              />
            </div>
            <div class="col-md-4">
              <BranchList
                v-model="model"
                :validate="errors"
                class="ts-w-full ts-border ts-p-4 ts-rounded-lg ts-border-gray-200"
              />
              <VendorList
                v-model="model"
                :validate="errors"
                class="ts-w-full ts-border ts-p-4 ts-mt-4 ts-rounded-lg ts-border-gray-200"
              />
              <AddOnItem
                v-model="model"
                :validate="errors"
                class="ts-w-full ts-border ts-p-4 ts-mt-4 ts-rounded-lg ts-border-gray-200"
              />
            </div>
            <div class="col-md-4">
              <ProductPhoto
                v-model="model"
                :validate="errors"
                class="ts-w-full ts-border ts-p-4 ts-rounded-lg ts-border-gray-200"
              />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12">
              <ProSaleCodeList 
                v-model="model" 
                :validate="errors"
              />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button
                @click.prevent="$router.push({ name: 'product-profile' })"
              >{{ $t('cancel') }}</ts-button>
              <ts-button
                color="primary"
                outline
                :waiting="waiting_new"
                @click.prevent="saveAddNew"
              >{{ $t('save_add_new') }}</ts-button>
              <ts-button color="primary" :waiting="waiting" @click.prevent="save">{{ $t('save') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import ProductPhoto from './components/product-photo.vue'
import ProductInfo from './components/product-info.vue'
import BranchList from './components/branch-list.vue'
import VendorList from './components/vendor-list'
import ProSaleCodeList from './components/pro-sale-code-list.vue'
import AddOnItem from './components/add-on-item'

export default {
  name: 'productProfile',
  components: {
    ProductPhoto,
    ProductInfo,
    BranchList,
    ProSaleCodeList,
    VendorList,
    AddOnItem
  },
  data() {
    return {
      errors: new Errors(),
      waiting_new: false,
      waiting: false,
      loading: false,
      file: null,
      model: {
        product_id: 0,
        category_id: null,
        product_name_kh: null,
        product_name_en: null,
        barcode: null,
        uom_cat_id: null,
        product_type_id: null,
        pro_group_id: null,
        warehouse_storage_id: null,
        warehouse_storage_name: null,
        product_mode_id: null,
        age_eligible_from: null,
        age_eligible_to: null,
        minimum_reorder_qty: null,
        maximum_reorder_allow: null,
        is_expirable: false,
        is_feature: false,
        vat_eligible: false,
        is_generate_unique_serial: false,
        photo: null,
        product_sale_code: [],
        other_branch_list: [],
        vendor_list: [],
        recipes: []
      }
    }
  },
  methods: {
    ...mapActions('product/profile', ['fetchBefore', 'store', 'upload']),
    async uploadPhoto(id) {
      if (this.file instanceof File || this.file instanceof Blob) {
        if (id > 0) {
          let formData = new FormData()
          formData.append('photo', this.file)
          let response = await this.upload({
            id: id,
            data: formData
          })
        }
      }
    },
    save() {
      let { photo, ...dataSend } = this.model
      this.file = photo
      this.waiting = true
      this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
          await this.uploadPhoto(response.product_id)
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-profile' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      let { photo, ...dataSend } = this.model
      this.file = photo
      this.waiting_new = true
      this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
          await this.uploadPhoto(response.id)
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.product_id = 0
      this.model.category_id = null
      this.model.product_name_kh = null
      this.model.product_name_en = null
      this.model.barcode = null
      this.model.uom_cat_id = null
      this.model.product_type_id = null
      this.model.product_mode_id = null
      this.model.warehouse_storage_id = null
      this.model.warehouse_storage_name = null
      this.model.age_eligible_from = null
      this.model.age_eligible_to = null
      this.model.minimum_reorder_qty = null
      this.model.maximum_reorder_allow = null
      this.model.is_expirable = false
      this.model.vat_eligible = false
      this.model.is_generate_unique_serial = false
      this.model.photo = null
      this.model.product_sale_code = []
      this.model.other_branch_list = []
      this.model.vendor_list = []
      this.model.recipes = []
      this.file = null
      this.errors = new Errors()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/profile/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loading = true
      vm.fetchBefore().finally(() => (vm.loading = false))
    })
  }
}
</script>